import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { SelectInput } from "../../../../common/form";

const ClientBlock = ({ disabled, blocs, accountType, create }) => (
  <div className="ClientSubsection">
    <h3>
      <FormattedMessage id="clients.form.block.title" />
    </h3>
    <Field
      id="blocId"
      name="blocId"
      component={SelectInput}
      options={blocs}
      required={true}
      disabled={disabled}
      label={<FormattedMessage id="clients.form.client.bloc" />}
    />
    <Field
      id="businessAccountType"
      name="businessAccountType"
      component={SelectInput}
      options={accountType}
      required={true}
      disabled={disabled || !create}
      addBlankOption={false}
      label={<FormattedMessage id="clients.form.client.accountType" />}
    />
  </div>
);

ClientBlock.propTypes = {
  accountType: PropTypes.array,
  disabled: PropTypes.bool,
  blocs: PropTypes.array,
  create: PropTypes.bool,
};

export default ClientBlock;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientBlock.js